<template>
  <div class="be-wrapper be-login">
    <div class="be-content">
      <div class="main-content container-fluid">
        <div class="splash-container">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-body">
                <span class="splash-title xs-pb-20"><h3>АИС "Курортный сбор"<br>Авторизация пользователя</h3></span>
                <div class="form-group" :class="{'has-error' : errors.has('email')}">
                  <label class="control-label">Email</label>
                  <input v-validate="'required|email'" class="form-control"
                         data-vv-as="email" data-vv-delay="1000"
                         :class="{'input': true, 'is-danger': errors.has('email') }" id="email" name="email"
                         type="text" placeholder="Email" v-model="email" autocomplete="email">
                  <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
                </div>
                <div class="form-group" :class="{'has-error': errors.has('password')}">
                  <label class="control-label">Пароль</label>
                  <input @keyup.enter="login()" v-validate="'required'" class="form-control"
                         data-vv-as="Пароль"
                         :class="{'input': true, 'is-danger': errors.has('password') }" id="password" name="password"
                         type="password" placeholder="Пароль" v-model="password" autocomplete="password">
                  <span v-show="errors.has('password')" class="text-danger">{{ errors.first('password') }}</span>
                  <router-link :to="{name:'resetPassword'}" class="pull-right">Забыли пароль?</router-link>
                </div>
                <!--<div class="form-group row login-tools">-->
                  <!--<div class="col-xs-6 login-remember">-->
                    <!--<div class="be-checkbox">-->
                      <!--<input type="checkbox" id="remember">-->
                      <!--<label for="remember">Запомнить меня</label>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</div>-->
              <div class="alert alert-danger" v-if="errorMessages" v-for="message in errorMessages">
                <p>{{ message }}</p>
              </div>
              <div class="form-group login-submit">
                <button class="btn btn-primary btn-xl" v-on:click="login()">Войти</button>
              </div>
              <div class="splash-footer"><span>Нет аккаунта?
            <router-link :to="{name:'signup'}">Зарегистрироваться</router-link>
            </span></div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  let jwtDecode = require('jwt-decode')
   import {USER_ROLE_GUEST, USER_ROLE_REGISTERED, USER_ROLE_ADMIN} from "./../../constants"

  export default {
    data () {
      return {
        email: null,
        password: null,
        errorMessages: null
      }
    },

    methods: {
      login () {
        this.errorMessages = null
        this.$validator.validateAll().then((result) => {
          if (result) {
            let self = this
            this.$auth.login({
              data: {email: this.email, password: this.password},
              rememberMe: true,
              fetchUser: false,
              success (response) {
                self.$auth.user(jwtDecode(self.$auth.token()))
                if (self.$auth.user().is_superuser) {
                  this.$user.set({role: USER_ROLE_ADMIN})
                } else if (self.$auth.user().is_guest) {
                  this.$user.set({role: USER_ROLE_GUEST})
                } else {
                  this.$user.set({role: USER_ROLE_REGISTERED})
                }
                self.$store.dispatch('init')
              },
              error (response) {
                if (response.response.status >= 400) {
                  self.errorMessages = response.response.data['system_message']
                  this.$snotify.error('При выполнении авторизации произошла ошибка.', 'Ошибка!')
                  if (response.response.data.system_message) {
                    self.errors.add('credentials', 'Ошибка авторизации! '.concat(response.response.data.system_message[0]))
                  } else {
                    this.$snotify.error(response.response.data, 'Ошибка!')
                  }
                }
              }
            })
          }
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue